// extracted by mini-css-extract-plugin
module.exports = {"bottom":"footer__bottom___rRl1W","pushToProduction":"footer__pushToProduction___EsUHX"};